/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface SafetyQuestionsProps {
  otherServiceDeclined: boolean | null;
  otherServiceDescription: string | null;
  otherServicesAreRespondingToTransferring: boolean | null;
  otherServiceResponseDescription: string | null;
}

export class SafetyQuestionsRecord extends Record<SafetyQuestionsProps>({
  otherServiceDeclined: null as any,
  otherServiceDescription: null as any,
  otherServicesAreRespondingToTransferring: null as any,
  otherServiceResponseDescription: null as any,
}) {
  public static fromJS(json: {
    otherServiceDeclined: boolean | null;
    otherServiceDescription: string | null;
    otherServicesAreRespondingToTransferring: boolean | null;
    otherServiceResponseDescription: string | null;
  }): SafetyQuestionsRecord {
    if (json == null) {
      throw new Error('SafetyQuestionsRecord.fromJS: parameter cannot be null');
    }
    return new SafetyQuestionsRecord({
      otherServiceDeclined: json.otherServiceDeclined,
      otherServiceDescription: json.otherServiceDescription,
      otherServicesAreRespondingToTransferring: json.otherServicesAreRespondingToTransferring,
      otherServiceResponseDescription: json.otherServiceResponseDescription,
    });
  }

  public static fromJSUnsafe(json: {
    otherServiceDeclined: boolean | null;
    otherServiceDescription: string | null;
    otherServicesAreRespondingToTransferring: boolean | null;
    otherServiceResponseDescription: string | null;
  }): [SafetyQuestionsRecord, Error[]] {
    if (json == null) {
      throw new Error('SafetyQuestionsRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new SafetyQuestionsRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      otherServiceDeclined: tryOrDefault(
        () => json.otherServiceDeclined,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      otherServiceDescription: tryOrDefault(
        () => json.otherServiceDescription,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      otherServicesAreRespondingToTransferring: tryOrDefault(
        () => json.otherServicesAreRespondingToTransferring,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      otherServiceResponseDescription: tryOrDefault(
        () => json.otherServiceResponseDescription,
        (err) => errors.push(err),
      )!,
    });

    return [record, errors];
  }

  constructor(props: SafetyQuestionsProps) {
    super(props);
    if (props == null) {
      throw new Error('SafetyQuestionsRecord constructor parameter cannot be null');
    }
  }
}

export abstract class SafetyQuestionsViewModelBase implements SafetyQuestionsProps {
  protected readonly _props: SafetyQuestionsProps;
  private _json?: SafetyQuestionsProps;

  get otherServiceDeclined(): boolean | null {
    return this._props.otherServiceDeclined;
  }
  get otherServiceDescription(): string | null {
    return this._props.otherServiceDescription;
  }
  get otherServicesAreRespondingToTransferring(): boolean | null {
    return this._props.otherServicesAreRespondingToTransferring;
  }
  get otherServiceResponseDescription(): string | null {
    return this._props.otherServiceResponseDescription;
  }

  constructor(props: SafetyQuestionsProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        otherServiceDeclined: this._props.otherServiceDeclined,
        otherServiceDescription: this._props.otherServiceDescription,
        otherServicesAreRespondingToTransferring:
          this._props.otherServicesAreRespondingToTransferring,
        otherServiceResponseDescription: this._props.otherServiceResponseDescription,
      };
    }
    return this._json;
  }
}
